import { Card, Descriptions } from 'antd'
import { useTranslation } from 'react-i18next'

import type { ReceivedCancellationRequestRoot } from '@repo/sdk'

import { StatusBadge } from '../../components/StatusBadge'
import { useCancellationStatusConfig } from './cancellationStatusConfig'
import { useCancellationReasonLabels } from './cancellationReasonConfig'
import { formatKstDateTime } from '../../utils/formatKstDateTime'

interface CancellationInfoCardProps {
  cancellation: ReceivedCancellationRequestRoot
}

export function CancellationInfoCard({ cancellation }: CancellationInfoCardProps) {
  const { t } = useTranslation()
  const statusConfig = useCancellationStatusConfig()
  const reasonLabels = useCancellationReasonLabels()

  return (
    <Card title={t('pages.cancellations.sections.cancellationInfo')} bordered>
      <Descriptions column={1} size="small">
        <Descriptions.Item label={t('pages.cancellations.fields.cancellationId')}>
          {cancellation.cancellationId}
        </Descriptions.Item>
        <Descriptions.Item label={t('pages.cancellations.fields.status')}>
          <StatusBadge status={cancellation.status} configMap={statusConfig} />
        </Descriptions.Item>
        <Descriptions.Item label={t('pages.cancellations.fields.initiatedBy')}>
          {t(`common.initiatedBy.${cancellation.initiatedBy}`)}
        </Descriptions.Item>
        <Descriptions.Item label={t('pages.cancellations.fields.reason')}>
          {reasonLabels[cancellation.reasonType] ?? cancellation.reasonType}
        </Descriptions.Item>
        <Descriptions.Item label={t('pages.cancellations.fields.reasonDescription')}>
          {cancellation.reasonDescription ?? '-'}
        </Descriptions.Item>
        <Descriptions.Item label={t('pages.cancellations.fields.requestDateTime')}>
          {formatKstDateTime(cancellation.requestedAt, 'YYYY-MM-DD HH:mm:ss')}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  )
}
